import { setRangeMax } from './helpers';

export const setLivingAreaMax = setRangeMax('living_area');
